import React from 'react';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {CircleLoader} from 'react-spinners';
import {css} from '@emotion/core';

import {AppState} from './../Store';
import {Page} from '../Models';
import {Article} from '../Services/ArticleService';
import {clearArticle} from '../Store/Articles/Actions';
import {
  setPageCreator,
  setCategoryCreator,
  setAuthorCreator,
} from '../Store/Home/Actions';

import ArticlePreview from '../Components/ArticlePreview';
import LoadMore from '../Components/LoadMore';

interface HomeProps {
  category?: string;
  author?: string;
  search?: string;

  authorName: string;
  page: number;
  articles: Page<Article>;
  loading: boolean;

  clearArticle: typeof clearArticle;
  setPage: (page: number) => Promise<void>;
  setCategory: (category: string) => Promise<void>;
  setAuthor: (author: number) => Promise<void>;
}

function Home({
  category,
  author,
  search,

  page,
  authorName,
  articles,
  loading,
  setPage,
}: HomeProps) {
  const getBreadcrumb = () => {
    if (category !== undefined) {
      return (
        <h5 className="title">{category}</h5>
      );
    } else if (author !== undefined) {
      return (
        <h5 className="title">{authorName}</h5>
      );
    } else if (search !== undefined) {
      return (
        <h5 className="title">Search Results</h5>
      );
    } else {
      return (
        <h5 className="title">My Feed</h5>
      );
    }
  };

  let fragment = '/public/';
  if (category !== undefined) {
    fragment = `${fragment}/category/${category}`;
  } else if (author !== undefined) {
    fragment = `${fragment}/author/${author}`;
  } else if (search !== undefined) {
    fragment = `${fragment}/search/${search}`;
  }

  return (
    <div>
      <div className="post-content-area mb-100">
        <div className="world-category-area">
          {getBreadcrumb()}
          <div className="tab-content">
            {loading
              ? <CircleLoader
                css={css`
                    display: block;
                    margin: 0 auto;
                  `}
              />
              : (
                articles.items.map(art => {
                  return <ArticlePreview key={art.id} article={art} vertical={false} />;
                })
              )
            }
          </div>
        </div>
      </div>
      <div className="page-container">
        <div className="pages">
          <LoadMore digits={2} currentPage={page} pages={articles.pageCount} callback={setPage} fragment={fragment} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppState) => ({
  auth: state.auth,
  authorName: state.home.authorName,
  page: state.home.currentPage,
  articles: state.home.articles,
  loading: state.home.loading,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    clearArticle: () => dispatch(clearArticle()),
    setPage: (page: number) => dispatch(setPageCreator(page)),
    setAuthor: (author: number) => dispatch(setAuthorCreator(author)),
    setCategory: (category: string) => dispatch(setCategoryCreator(category)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
